
import { useTranslation } from "react-i18next";
import styles from "./PartSurveyItemAdminUsed.module.scss";
import { useState } from "react";

import checkicon from 'assets/icons/check.png'
import circleicon from 'assets/icons/circle.png'
import squareicon from 'assets/icons/square.png'
import checksquareicon from 'assets/icons/square_check.png'
import pieeeeechart from 'assets/icons/pieeeeechart.png'
import Notification from "utils/Notifications";

import { updatePointsPart } from "service/SurveyService";
import { EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

const PartSurveyItemUse = ({ item, item_selected, item_selected_data, index, setRender }) => {
    const { t } = useTranslation("common");


    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });

    const getSelectedData = (defendantId, key) => {
        if (!Array.isArray(item_selected_data)) {
            return '';
        }
    
        for (const survey of item_selected_data) {
            if (!Array.isArray(survey.userusetsurveypart_employee_tsurveys)) continue;
    
            for (const test of survey.userusetsurveypart_employee_tsurveys) {
                if (test.defendant === defendantId) {
                    return test[key] || '';
                }
            }
        }
    
        return '';
    };
    
    
    

    const DraftContent = ({ draftData }) => {
        let contentState;
        try {
            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            contentState = convertFromRaw(parsedData);
        } catch (error) {
            return <p>Invalid content format</p>;
        }

        const editorState = EditorState.createWithContent(contentState);

        return (
            <div st>
                <Editor editorState={editorState} readOnly toolbarHidden />
            </div>
        );
    };


    const [text, setText] = useState('');
    const [settextelem, setTextElem] = useState(null);


    const handleSubmit = () => {
        try {
            const formData = new FormData();


            formData.append('text', text)
            updatePointsPart(item_selected_data[0]?.id, formData);
            setTextElem(t("surveys.adminUse.awaiting_update"));
            setNotify({
                isOpen: true,
                message: t("surveys.item.data_sent"),
                type: "success",
            });
            setRender(true);
        } catch (error) {
            setNotify({
                isOpen: true,
                message: t("surveys.item.data_error"),
                type: "error",
            });
        }
    };
    return (


        <div className={styles.defendant_card_selection} >

            {item.image &&
                <img
                    src={item.image}
                    className={styles.img_file}
                />
            }
            <div className={styles.defendant_card_selection_body}>

                <h3 style={{ marginTop: "-16px" }}> <DraftContent draftData={item.body} /></h3>
                {((Number(item_selected) !== Number(item.id)) && item.type_defendant !== "infoText") &&

                    <div className={styles.defendant_card_selection_body_defendant}>
                       
                        {t('surveys.adminUse.not_answered')}
                    </div>
                }
                {Number(item_selected) === Number(item.id) &&
                    <>


                        <h4 style={{ display: 'flex', alignItems: 'start', justifyContent: 'start', width: "100%", flexDirection: "column" }}>  {t('surveys.adminUse.user_answer')}:</h4>
                        <div className={styles.defendant_card_selection_body_defendant}>
                            {item.defendant_part_survey.map((defendant) => (
                                <div key={defendant.id} style={{ width: '100%' }}>
                                    {!['freeTextDefendant', 'infoText', 'fileUpload'].includes(item.type_defendant) && (
                                        <div className={styles.defendant_card_header}>
                                            {item.type_defendant === 'sequenceOrdering' && (
                                                <>
                                                    <DraftContent draftData={defendant.title} />
                                                    <select className={styles.point_check_num_text} value={getSelectedData(defendant.id, 'sequences_selectedNumber') || 1}>
                                                        <option value={getSelectedData(defendant.id, 'sequences_selectedNumber') || 1}>
                                                            {getSelectedData(defendant.id, 'sequences_selectedNumber') || 1}
                                                        </option>
                                                    </select>
                                                </>
                                            )}
                                            {item.type_defendant === 'slider' && (
                                                <div className={styles.slider_container}>
                                                    <h4>{defendant.type_input_txt}</h4>
                                                    {[getSelectedData(defendant.id, 'rdefendant'), defendant.rdefendant].map((val, index) => (
                                                        <div key={index} className={styles.slider_min_max}>
                                                            <input type="range" min={Math.min(defendant.min_len, defendant.max_len)} max={Math.max(defendant.min_len, defendant.max_len)} value={val || 0} style={{ width: '100%' }} readOnly />
                                                            <span className={styles.slider_min_max_res}>{val || ''}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                         {['numericInput', 'textInput'].includes(item.type_defendant) && (
  <input
    type={item.type_defendant === 'numericInput' ? 'number' : 'text'}
    value={getSelectedData(defendant.id, item.type_defendant === 'numericInput' ? 'type_input_int' : 'type_input_txt')}
    style={{
      border: '1px solid #292121',
      padding: '5px 10px',
      borderRadius: '6px',
      background: item.type_defendant === 'textInput' ? 'transparent' : 'transparent',
    }}
    placeholder={`${t('surveys.adminUse.enter')} ${item.type_defendant === 'numericInput' ? t('surveys.adminUse.digits') : t('surveys.adminUse.text')}`}
    readOnly
  />
)}

                                            {['singleSelection', 'multipleSelection'].includes(item.type_defendant) && (
                                                <>
                                                    <input type={item.type_defendant === 'singleSelection' ? 'radio' : 'checkbox'} id={`defendant-${defendant.id}`} checked={!!getSelectedData(defendant.id, 'right_defendant')} readOnly />
                                                    <DraftContent draftData={defendant.title} />
                                                </>
                                            )}
                                        </div>
                                    )}
                                    {item.type_defendant === 'freeTextDefendant' && (
                                        <div className={styles.defendant_card_header}>
                                            <div className={styles.defendant_card_second_div}>{getSelectedData(defendant.id, 'free_response') || t('surveys.adminUse.text_not_found')}</div>
                                        </div>
                                    )}
                                    {item.type_defendant === 'fileUpload' && (
                                        <div className={styles.defendant_card_header}>
                                            <div className={styles.defendant_card_second_div}>
                                                {getSelectedData(defendant.id, 'file') ? (
                                                    <>
                                                        <strong>{t('surveys.adminUse.file_name')}:</strong> {getSelectedData(defendant.id, 'file').split('/').pop() || t('surveys.adminUse.file_name_not_found')}
                                                        <br />
                                                        <button
                                                            className={styles.button_style}
                                                            onClick={() => {
                                                                const fileUrl = getSelectedData(defendant.id, 'file');
                                                                if (fileUrl) {
                                                                    const link = document.createElement('a');
                                                                    link.href = fileUrl;
                                                                    link.download = 'downloaded_file';
                                                                    document.body.appendChild(link);
                                                                    link.click();
                                                                    document.body.removeChild(link);
                                                                } else {
                                                                    alert(t('surveys.adminUse.file_not_found_for_download'));
                                                                }
                                                            }}
                                                        >
                                                            {t('surveys.adminUse.download_file')}
                                                        </button>
                                                    </>
                                                ) : (
                                                    <div>{t('surveys.adminUse.no_data_found')}</div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                    {defendant.file && <img src={defendant.file} className={styles.img_file} alt="Uploaded file" />}
                                </div>
                            ))}
                            {item.comment && (
                                <div style={{ marginTop: '40px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                                    <DraftContent draftData={item.comment} />
                                </div>
                            )}
                        </div>
                    </>
                }
            </div>

            <hr></hr>
            <Notification notify={notify} setNotify={setNotify} />
        </div >


    );
};

export default PartSurveyItemUse;
